import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import {fromAPI} from './model';

export const search = (term, entityTypes = [], institutionIds = [], organizationIds = []) => {
    return RESTClient.getAuthenticatedObservable('v2/search', {term, entityTypes, institutionIds, organizationIds}).map(
        data => ({
            searchItems: List(data.results).map(fromAPI),
        }),
    );
};
